/**
 * Persistance des flags métier du partenaire (features de la config serveur).
 *
 * Source unique pour les deux endpoints qui les renvoient : le login et /tokenIsValid,
 * ce dernier appelé toutes les 30 s par le heartbeat. Sans ce rafraîchissement, un admin
 * déjà connecté garderait les flags de son login après un changement de config.
 *
 * Fail-closed : une réponse sans flags ou un JSON illisible valent "aucun flag actif",
 * jamais une activation par défaut. Le serveur reste de toute façon autoritaire, ces
 * valeurs ne servent qu'à l'affichage.
 */

const STORAGE_KEY = "partnerFeatures";

export function persistPartnerFeatures(features) {
  const value = features && typeof features === "object" ? features : {};
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
}

export function readPartnerFeatures() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
  } catch (e) {
    return {};
  }
}

export function clearPartnerFeatures() {
  localStorage.removeItem(STORAGE_KEY);
}
